import { Platform } from 'react-native';
import * as SecureStore from 'expo-secure-store';

type StorageDriver = {
  getItem: (key: string) => Promise<string | null>;
  setItem: (key: string, value: string) => Promise<void>;
  deleteItem: (key: string) => Promise<void>;
};

const webStorage: StorageDriver = {
  async getItem(key) {
    try {
      return typeof window !== 'undefined' ? window.localStorage.getItem(key) : null;
    } catch {
      return null;
    }
  },
  async setItem(key, value) {
    try {
      if (typeof window !== 'undefined') window.localStorage.setItem(key, value);
    } catch {}
  },
  async deleteItem(key) {
    try {
      if (typeof window !== 'undefined') window.localStorage.removeItem(key);
    } catch {}
  },
};

const nativeStorage: StorageDriver = {
  async getItem(key) { return SecureStore.getItemAsync(key); },
  async setItem(key, value) { return SecureStore.setItemAsync(key, value); },
  async deleteItem(key) { return SecureStore.deleteItemAsync(key); },
};

export const storage: StorageDriver = Platform.OS === 'web' ? webStorage : nativeStorage;


